import { MdModeEdit } from 'react-icons/md'
import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  margin-top: 64px;
  position: relative;
  margin-bottom: 48px;
  ${({ theme }) => theme.media.tablet} {
    padding: 0 32px;
    margin-top: 48px;
  }
  ${({ theme }) => theme.media.phone} {
    margin-top: 48px;
    flex-direction: column;
    padding: 0 16px;
    margin-bottom: 32px;
  }
`
export const AvatarContainer = styled.div`
  min-width: 200px;
  min-height: 200px;
  max-width: 200px;
  max-height: 200px;
  position: relative;
  margin-right: 16px;

  ${({ theme }) => theme.media.phone} {
    width: 166px;
    height: 166px;
    margin-bottom: 34px;
  }
`

export const Avatar = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 50px;
  position: relative;
  overflow: hidden;
  text-transform: uppercase;

  ${({ theme }) => theme.media.phone} {
    font-size: 40px;
  }
`
export const ImgProfile = styled.div`
  height: 100%;
  width: 100%;
  ${({ src }) =>
    src &&
    css`
      background-image: ${`url(${src})`};
      background-size: cover;
      background-position: center;
    `};
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const Title = styled.div`
  ${({ theme }) => theme.font.h2}
  margin-bottom: 10px;
  display: flex;
  align-items: center;
`

export const Links = styled.div`
  flex: 1;
  display: flex;
  margin-bottom: 10px;
`
export const RefLink = styled.a`
  cursor: pointer;
  height: 24px;
  width: 24px;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(4 4 4 / 62%);
  & + & {
    margin-left: 25px;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`

export const Name = styled.div`
  margin-bottom: 8px;
`

const DescContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: flex-start;

  ${({ theme }) => theme.media.phone} {
    grid-row: unset !important;
  }
`
// const DescLabel = styled.div`
//   ${({ theme }) => theme.font.body}
// `
const DescValue = styled.div`
  ${({ theme }) => theme.font.body2}
  color: ${({ theme }) => theme.colors.grey};
`

export const Desc = ({ value, ...rest }) => {
  return (
    <DescContainer {...rest}>
      <DescValue>{value}</DescValue>
    </DescContainer>
  )
}

const StyledButton = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 1;
  background-color: ${({ theme }) => theme.colors.grey};
  color: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  border-radius: 50%;
  font-size: 24px;
  padding: 10px;
  transition: all 0.2s ease-in-out;
  &:hover {
    color: ${({ theme }) => theme.colors.grey};
    background-color: ${({ theme }) => theme.colors.grey2};
  }

  ${({ theme }) => theme.media.phone} {
    right: 20px;
  }
`

export const EditButton = props => {
  return (
    <StyledButton aria-label="editicon" color="black" {...props}>
      <MdModeEdit />
    </StyledButton>
  )
}

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
`
export const Info = styled.div`
  display: flex;
  flex-direction: column;
  width: fit-content;
`
export const InfoTitle = styled.div`
  ${({ theme }) => theme.font.body2}
`
export const InfoValue = styled.div`
  ${({ theme }) => theme.font.h3}
`
export const KarmaValue = styled(InfoValue)`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.accentP};
  margin-bottom: 10px;
`

const MeritContainer = styled.div`
  padding: 0 72px 64px;
  ${({ theme }) => theme.media.phone} {
    padding: 0 12px 64px;
  }
`
const PointsTable = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 0 16px;
  ${({ theme }) => theme.media.phone} {
    grid-template-columns: 1fr 70px;
    strong:nth-child(even),
    div:nth-child(even) {
      text-align: right;
    }
  }
`

export const MeritInfo = () => {
  return (
    <MeritContainer>
      <h2>
        <strong>What is Merit?</strong>
      </h2>
      <p>
        Merit is a scoring system that represent trust in the TrialSite
        community. The higher your Merit score, the more trusted you are as a
        community member.
      </p>
      <h3>
        <strong>How to earn Merit?</strong>
      </h3>
      <p>
        Increasing your Merit is easy. All you have to do is contribute to the
        TrailSite community in a positive way with the following activities:
      </p>
      <p>
        <PointsTable>
          <strong>Activity</strong>
          <strong>Points</strong>
          <div>Publish an article </div>
          <div>7 points</div>
          <div>Post a comment </div>
          <div>2 points</div>
          <div>Follow a subject </div>
          <div>2 points</div>
          <div>Follow a writer </div>
          <div>3 points</div>
          <div>Someone follows you </div>
          <div>5 points</div>
          <div>Your article appears on the home page </div>
          <div>10 points</div>
          <div>Someone comments on your article </div>
          <div>7 points</div>
        </PointsTable>
      </p>
    </MeritContainer>
  )
}
